<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="商品名" label-width="80px">
        <el-input v-model="searchForm.name" clearable placeholder="商品名">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getStoreGoods(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="getod()">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      element-loading-background="rgba(0, 0, 0, 0.8)"
      element-loading-spinner="el-icon-loading"
      element-loading-text="拼命加载中"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        label="商品封面"
        prop="storeGoodsCover"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.cover"
            fit="scale-down"
            style="width: 70px; height: 70px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品名称"
        prop="name"
        width="260"
      ></el-table-column>

      <el-table-column align="center" label="商品分类" width="148">
        <template slot-scope="scope">
          {{ scope.row.classifyName }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品备注" width="148">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.isGroupBuying == 1"
            size="small"
            type="success"
            >拼团商品
          </el-tag>
          <el-tag v-if="scope.row.isHot == 1" size="small" type="success"
            >热门商品
          </el-tag>
          <el-tag
            v-if="scope.row.isLimitedTimeDiscount == 1"
            size="small"
            type="success"
            >限时秒杀
          </el-tag>
          <el-tag v-if="scope.row.isPoint == 1" size="small" type="success"
            >积分兑换
          </el-tag>
          <el-tag v-if="scope.row.isRecommend == 1" size="small" type="success"
            >推荐商品
          </el-tag>
          <el-tag
            v-if="scope.row.isCrowdfunding == 1"
            size="small"
            type="success"
            >众筹商品
          </el-tag>
          <el-tag v-if="scope.row.isGift == 1" size="small" type="success"
            >赠品
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品规格"
        prop="parameters"
        width="400"
      >
        <template slot-scope="{ row }">
          <div
            v-for="(item, index) in row.commoditSpecificationsList"
            :key="index"
          >
            规格名：{{ item.commoditSpecifications }}； 原价：{{
              item.originalPrice
            }}
            ；

            {{ item.sellingPriceName || "售价" }}：{{ item.price }}；
            {{ item.storePriceName || "达人价" }}：{{ item.storePrice }}；

            <span v-if="row.isGroupBuying == 1"
              >拼团价：{{ item.groupBuyingPrice || 0 }}；</span
            >
            <span v-if="row.isLimitedTimeDiscount == 1"
              >秒杀价：{{ item.limitedTimeDiscountPrice || 0 }}；</span
            >
            <span v-if="row.isCrowdfunding == 1"
              >全款众筹价：{{ item.crowdfundingPrice || 0 }}；</span
            >
            <span v-if="row.isCrowdfunding == 1"
              >抽奖众筹价：{{ item.crowdfundingLotteryPrice || 0 }}；</span
            >
            <span v-if="row.isPoint == 1"
              >兑换积分：{{ item.exchangePointsNum || 0 }}；</span
            >
            <span v-if="row.isGift == 1"
              >库存：{{ item.inventory || 0 }}；</span
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="商品标签"
        prop="parameters"
        width="300"
      >
        <template slot-scope="{ row }">
          <div v-for="(item, index) in row.productLabelsList" :key="index">
            {{ item }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="商品销量"
        prop="salesVolume"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        label="是否为赠品"
        prop="isGift"
        width="140"
      >
        <template slot-scope="{ row }">
          {{ row.isGift == 1 ? "是" : "否" }}
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="商品参数"
        prop="parameters"
        width="150"
      ></el-table-column>
      <el-table-column
        align="center"
        label="排序"
        prop="sort"
        width="120"
      ></el-table-column>
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="180"
      >
        <template slot-scope="scope">
          <el-button
            v-if="hasAuth('sys:singProduct:shangjia')"
            slot="reference"
            plain
            type="success"
            @click="updStoreGoodsIsOnframe(scope.row)"
          >
            审核上架
          </el-button>
          <el-button plain type="primary" @click="lookinfo(scope.row)"
            >详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="current"
      :page-size="size"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="smvisible"
      append-to-body
      class="dialogClass"
      title="详情"
      width="1000px"
    >
      <div class="flexcen">
        <div class="titcon">商品名称</div>
        <div class="">{{ shopinfo.name }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">单位</div>
        <div class="">{{ shopinfo.unit }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品参数</div>
        <div class="">{{ shopinfo.parameters }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">运费</div>
        <div class="">{{ shopinfo.freight }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">排序</div>
        <div class="">{{ shopinfo.sort }}</div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品标签</div>
        <div class="">
          <el-tag
            v-for="(tag, i) in shopinfo.productLabelsList"
            :key="i"
            size="mini"
            >{{ tag }}</el-tag
          >
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">属性</div>
        <div class="">
          <el-tag v-if="shopinfo.isHot === 1" size="mini">热门</el-tag>
          <el-tag v-if="shopinfo.isRecommend === 1" size="mini">推荐</el-tag>
          <el-tag v-if="shopinfo.isNewProductLaunch === 1" size="mini"
            >新品</el-tag
          >
          <el-tag v-if="shopinfo.isGift === 1" size="mini">赠品</el-tag>
          <el-tag v-if="shopinfo.isPoint === 1" size="mini">积分兑换</el-tag>
          <el-tag v-if="shopinfo.isGroupBuying === 1" size="mini">拼团</el-tag>
          <el-tag v-if="shopinfo.isLimitedTimeDiscount === 1" size="mini"
            >限时秒杀</el-tag
          >
          <el-tag v-if="shopinfo.isCrowdfunding === 1" size="mini">众筹</el-tag>
        </div>
      </div>
      <div v-if="shopinfo.isGroupBuying === 1" class="flexcen">
        <div class="titcon">拼团人数</div>
        <div class="">{{ shopinfo.groupBuyingNum }}</div>
      </div>
      <div v-if="shopinfo.isLimitedTimeDiscount === 1" class="flexcen">
        <div class="titcon">秒杀人数</div>
        <div class="">{{ shopinfo.limitedTimeDiscountNum }}</div>
      </div>
      <div v-if="shopinfo.isLimitedTimeDiscount === 1" class="flexcen">
        <div class="titcon">秒杀截止</div>
        <div class="">{{ shopinfo.limitedTimeDiscountEndTime }}</div>
      </div>
      <div v-if="shopinfo.isLimitedTimeDiscount === 1" class="flexcen">
        <div class="titcon">秒杀件数</div>
        <div class="">{{ shopinfo.limitedTimeDiscountCommodityNum }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">众筹开始</div>
        <div class="">{{ shopinfo.crowdfundingStartTime }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">众筹结束</div>
        <div class="">{{ shopinfo.crowdfundingEndTime }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">发货时间</div>
        <div class="">{{ shopinfo.crowdfundingDeliveryTime }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">可抽奖人数</div>
        <div class="">{{ shopinfo.crowdfundingLuckyNum }}</div>
      </div>
      <div v-if="shopinfo.isCrowdfunding === 1" class="flexcen">
        <div class="titcon">幸运用户数</div>
        <div class="">{{ shopinfo.crowdfundingLuckyUser }}</div>
      </div>
      <div style="height: 20px"></div>
      <div class="issline"></div>
      <div style="height: 20px"></div>
      <div>
        <div class="mb8">商品规格</div>
        <el-table
          :data="shopinfo.commoditSpecificationsList || []"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="commoditSpecifications"
            label="规格名"
            min-width="140"
          ></el-table-column>
          <el-table-column
            prop="originalPrice"
            label="原价"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="price"
            :label="
              shopinfo.commoditSpecificationsList &&
              shopinfo.commoditSpecificationsList.length > 0 &&
              shopinfo.commoditSpecificationsList[0].sellingPriceName
                ? shopinfo.commoditSpecificationsList[0].sellingPriceName
                : '售价'
            "
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="storePrice"
            :label="
              shopinfo.commoditSpecificationsList &&
              shopinfo.commoditSpecificationsList.length > 0 &&
              shopinfo.commoditSpecificationsList[0].storePriceName
                ? shopinfo.commoditSpecificationsList[0].storePriceName
                : '达人价'
            "
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isGift === 1"
            prop="inventory"
            label="库存"
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isGroupBuying === 1"
            prop="groupBuyingPrice"
            label="拼团价"
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isLimitedTimeDiscount === 1"
            prop="limitedTimeDiscountPrice"
            label="秒杀价"
            min-width="100"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isCrowdfunding === 1"
            prop="crowdfundingPrice"
            label="全款众筹价"
            min-width="120"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isCrowdfunding === 1"
            prop="crowdfundingLotteryPrice"
            label="抽奖众筹价"
            min-width="120"
          ></el-table-column>
          <el-table-column
            v-if="shopinfo.isPoint === 1"
            prop="exchangePointsNum"
            label="兑换积分"
            min-width="100"
          ></el-table-column>
        </el-table>
        <div
          v-for="(spec, sIndex) in shopinfo.commoditSpecificationsList || []"
          :key="sIndex"
          style="margin-top: 10px"
        >
          <div
            v-if="
              spec.tcommodityFlashSalePrices &&
              spec.tcommodityFlashSalePrices.length > 0
            "
          >
            <div class="mb8">规格 {{ sIndex + 1 }} 阶梯单价</div>
            <el-table
              :data="spec.tcommodityFlashSalePrices"
              border
              stripe
              style="width: 100%"
            >
              <el-table-column
                prop="startNum"
                label="开始数量"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="endNum"
                label="结束数量"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="price"
                label="每件单价/元"
                min-width="140"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div style="height: 20px"></div>
      <div class="issline"></div>
      <div style="height: 20px"></div>
      <div class="flexcen">
        <div class="titcon">封面</div>
        <div class="">
          <img
            v-for="(cover, i) in shopinfo.videoCoverList"
            :key="i"
            :src="cover"
            alt=""
            class="stimg"
          />
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">轮播图</div>
        <div class="">
          <img
            v-for="(img, i) in shopinfo.imgListArray"
            :key="i"
            :src="img"
            alt=""
            class="stimg"
          />
        </div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品说明</div>
        <div class="" v-html="shopinfo.explain"></div>
      </div>
      <div class="flexcen">
        <div class="titcon">商品详情</div>
        <div class="" v-html="shopinfo.imgDetail"></div>
      </div>
      <div class="flexcen">
        <div class="titcon">三证信息</div>
        <div class="" v-html="shopinfo.threeCertificateInformation"></div>
      </div>
    </el-dialog>
    <el-dialog
      :before-close="handleClose"
      title="审核"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="reason">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="editForm.reason"
          >
          </el-input>
        </el-form-item>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "singProduct",
  components: {},
  data() {
    return {
      editForm: {
        id: "",
        status: 1,
        reason: "",
      },
      rules: {},
      dialogVisible: false,
      smvisible: false,
      dalong: false,
      sortVisible: false,
      boxItemsVisible: false,
      nonQueuingVisible: false,
      getParametervisible: false,
      dialog: false,
      gardenNames: "",
      shopinfo: "",
      loading: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        classifyFirstId: "",
      },
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      GardenIdList: [],
      typeList: [],
      total: 0,
      size: 10,
      current: 1,
      addUpdateSingProductVisible: false,
      updateGoodssVisible: false,
      balancePaymentVisble: false,
      ids: [],
      classifyId: [],
      supList: [],
    };
  },
  created() {
    this.getStoreGoods();
    this.getTypeList();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    submitForm() {
      this.$axios
        .post("/admin/commodity/reviewUpperCommodity", this.editForm)
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.handleClose();
            this.getStoreGoods();
          } else {
            this.$message({
              message: res.msg || "操作失败",
              type: "error",
            });
          }
        });
    },
    lookinfo(row) {
      this.$axios
        .post("/admin/commodity/getCommodityDetail", {
          id: row.id,
        })
        .then((res) => {
          this.smvisible = true;
          const data = res.data || {};
          const videoCoverList = data.videoCover
            ? String(data.videoCover).split(",")
            : [];
          const imgListArray = Array.isArray(data.imgList)
            ? data.imgList
            : data.imgList
            ? String(data.imgList).split(",")
            : [];
          if (Array.isArray(data.commoditSpecificationsList)) {
            data.commoditSpecificationsList.forEach((spec) => {
              if (!spec.tcommodityFlashSalePrices) {
                spec.tcommodityFlashSalePrices = [];
              }
            });
          }
          this.shopinfo = Object.assign({}, data, {
            videoCoverList,
            imgListArray,
          });
        });
    },
    getod() {
      this.searchForm = {
        name: "",
        storeGoodsType: "",
        brandId: "",
        classifyFirstId: "",
        classifyId: "",
      };
      this.classifyId = [];
      this.getStoreGoods(1);
    },

    handleSizeChange(val) {
      this.size = val;
      this.getStoreGoods();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getStoreGoods();
    },

    getTypeList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.typeList = res.data;
        });
    },
    getStoreGoods(current) {
      if (this.classifyId.length > 0) {
        this.searchForm.classifyFirstId = this.classifyId[0];
        if (this.classifyId.length > 1) {
          this.typeList.map((item) => {
            item.children.map((itrs) => {
              if (this.classifyId[1] == itrs.id) {
                this.searchForm.classifyId = itrs.uid;
              }
            });
          });
        } else {
          this.searchForm.classifyId = "";
        }
      } else {
        this.searchForm.classifyId = "";
        this.searchForm.classifyFirstId = "";
      }

      if (current) {
        this.current = current;
      }

      this.loading = true;
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.searchForm.status = 0;
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
          this.loading = false;
        });
    },

    //下架、上架商城商品
    updStoreGoodsIsOnframe(model) {
      this.editForm.id = model.id;
      this.editForm.status = 1;
      this.editForm.reason = "";
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 30px;
  margin-right: 10px;
  margin-top: 5px;
}

.titcon {
  width: 150px;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.issline {
  height: 1px;
  background: #e1e1e1;
  width: 100%;
}

.stimg {
  width: 50px;
  height: 50px;
  border-radius: 6rpx;
  display: inline-block;
  margin-right: 10rpx;
}

.mb8 {
  margin-bottom: 10px;
}
</style>
